import * as React from 'react';
import { Section as SectionStandard } from '@emorg-prd/standard-react';
import './Section.css';

type TitleFontSize =
	| 'xsmall'
	| 'small'
	| 'small-2'
	| 'med'
	| 'med-2'
	| 'med-3'
	| 'large'
	| 'large-2'
	| 'large-3'
	| 'xl';

type TitleMarginBottom = 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';

interface SectionProps extends React.ComponentProps<typeof SectionStandard> {
	className?: string;
	marginNone?: boolean;
	isInError?: boolean;
	titleFontSize?: TitleFontSize;
	titleMarginBottom?: TitleMarginBottom;
	titleAlignStart?: boolean;
}

const Section = (props: SectionProps) => {
	return (
		<SectionStandard
			{...props}
			title={props.title}
			underline={props.underline}
			color="em-c-section__header--underline-blue"
			optionalClass={`${props.className ?? ''} 
			${props.marginNone ? 'custom-section--margin-none' : ''}
			${props.isInError ? 'custom-section--error' : ''}
			${props.titleFontSize ? `custom-section--font-size-${props.titleFontSize}` : ''}
			${props.titleMarginBottom ? `custom-section--title-mb-${props.titleMarginBottom}` : ''}
			${props.titleAlignStart ? 'custom-section--title-align-start' : ''}
			 custom-section`}
		>
			{props.children}
		</SectionStandard>
	);
};

export { Section };
